import { pathBuilder } from 'config/paths/index';

export const root = '/action-requests';

const adminRoot = '/admin' + root;
export const adminPaths = pathBuilder(adminRoot);

export default pathBuilder(root);
